export default __webpack_public_path__ + "static/media/Hedgeshear.c6fd940a.jpg";